<template>
	<div class="floor visible" ref="floorRef">
		<div class="floor-header">
      <div class="floor-title">
        <!-- 动态分配样式 -->
        <!-- 修改：添加 floor-icon 类用于动画控制 -->
        <i :class="[currentStyle.icon, 'floor-icon']"
          :style="{ color: currentStyle.color, background: currentStyle.bgLight, padding: '10px', borderRadius: '10px' }"></i>
        <!-- 使用 floor.name -->
        <span :style="{ color: currentStyle.color }">{{ index + 1 }}F {{ floor.name }}</span>
      </div>
      <div class="floor-tags">
        <!-- 如果数据中没有 tags，展示默认标签，或者您可以根据 nameZh 生成 -->
        <span v-for="tag in defaultTags" :key="tag" :style="{ '--color': currentStyle.color }">{{ tag }}</span>
      </div>
    </div>
		<div class="floor-body">
			<!-- 3D 侧边栏 -->
			<div class="floor-side js-tilt"
				:style="{ background: `linear-gradient(165deg, ${currentStyle.color}, ${currentStyle.colorLight})` }"
				@mousemove="handleTilt" @mouseleave="resetTilt">
				<i :class="[currentStyle.icon, 'side-bg-icon']"></i>
				<!-- 副标题使用 name 或者写死 -->
				<h2 style="font-size:32px; margin-bottom:20px; position:relative; z-index:2;">{{ floor.name }}甄选</h2>
				<ul class="side-list" style="position:relative; z-index:2;">
					<!-- 侧边列表展示通用服务承诺 -->
					<li v-for="item in sideList" :key="item"><i class="fas fa-check"></i> {{ item }}</li>
				</ul>
			</div>

			<!-- 商品列表 -->
			<div class="goods-list">
				<el-card v-for="(prod, idx) in (floor.item || []).slice(0, 8)" :key="prod.id" class="goods-card"
					:body-style="{ padding: 0 }" shadow="never" :style="{ '--hover-color': currentStyle.color }"  @click="handleItemClick(prod)">
					<div class="goods-img" >
						<!-- 如果有图片显示图片，否则显示图标 -->
						<i :class="getIconByCas(idx)"></i>
					</div>
					<div class="goods-info">
						<!-- 显示中文名 -->
						<div class="goods-name" :title="prod.nameZh">{{ prod.nameZh }}</div>
						<!-- 新增：显示英文名和CAS号，作为辅助信息 -->
						<div class="goods-meta">
							<div class="goods-en text-ellipsis" :title="prod.nameEn">{{ prod.nameEn }}</div>
							<div class="goods-cas">CAS: {{ prod.cas }}</div>
						</div>
						<div class="goods-price">¥ {{ prod.price }}</div>
					</div>
					<div class="hover-action"
						:style="{ background: `linear-gradient(90deg, ${currentStyle.color}, ${currentStyle.colorLight})` }">
						查看详情
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from "vue-router";
const router = useRouter();

const props = defineProps({
	floor: {
		type: Object,
		required: true
	},
	index: {
		type: Number,
		required: true
	}
});

// 定义样式配置池，根据 index 循环使用
const styleConfigs = [
	{ color: '#2563eb', colorLight: '#60a5fa', bgLight: 'rgba(37, 99, 235, 0.1)', icon: 'fas fa-flask' }, // 蓝色
	{ color: '#059669', colorLight: '#34d399', bgLight: 'rgba(5, 150, 105, 0.1)', icon: 'fas fa-dna' },   // 绿色
	{ color: '#7c3aed', colorLight: '#a78bfa', bgLight: 'rgba(124, 58, 237, 0.1)', icon: 'fas fa-microscope' }, // 紫色
	{ color: '#ea580c', colorLight: '#fb923c', bgLight: 'rgba(234, 88, 12, 0.1)', icon: 'fas fa-atom' }  // 橙色
];

// 计算当前楼层的样式
const currentStyle = computed(() => {
	return styleConfigs[props.index % styleConfigs.length];
});

// 默认的侧边列表和标签
const sideList = ['现货极速发', '品类齐全', '提供质检谱图', '专业技术支持'];
const defaultTags = ['热门推荐', '新品上市', '促销'];

// 根据 CAS 号或其他逻辑简单返回一个图标，丰富无图时的显示
const getIconByCas = (idx) => {
	const icons = ['fas fa-vial', 'fas fa-flask', 'fas fa-microscope', 'fas fa-atom'];
	return icons[idx % icons.length]; // 循环使用图标
};

// 3D Tilt 逻辑
const handleTilt = (e) => {
	const card = e.currentTarget;
	const rect = card.getBoundingClientRect();
	const x = e.clientX - rect.left;
	const y = e.clientY - rect.top;
	const rotX = ((y - rect.height / 1.5) / rect.height / 1.5) * -20;
	const rotY = ((x - rect.width / 1.5) / rect.width / 1.5) * 20;
	card.style.transform = `perspective(500px) rotateX(${rotX}deg) rotateY(${rotY}deg) scale(1.02)`;
};

const resetTilt = (e) => {
	e.currentTarget.style.transform = `perspective(500px) rotateX(0) rotateY(0) scale(1.02)`;
};

const handleItemClick = (item) => {
  // 跳转到商品详情页
  console.log("点击商品:", item);
  router.push(`/product/detail/${item.cas}`);
};
</script>

<style scoped>
.floor {
	margin-top: 40px;
	transition: 0.5s;
}

.floor-header {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-bottom: 15px;
	border-bottom: 2px solid #f1f5f9;
	padding-bottom: 10px;
}

.floor-title {
	font-size: 24px;
	font-weight: 800;
	display: flex;
	align-items: center;
	gap: 10px;
}

.floor-icon {
  transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1); /* 使用贝塞尔曲线增加弹性感 */
}

.floor:hover .floor-icon {
  transform: rotateY(180deg);
}

.floor-tags span {
	font-size: 13px;
	color: #666;
	margin-left: 10px;
	cursor: pointer;
	padding: 4px 10px;
	background: #fff;
	border-radius: 12px;
}

.floor-tags span:hover {
	color: #fff;
	background: var(--color);
}

.floor-body {
	display: grid;
	grid-template-columns: 280px 1fr;
	gap: 20px;
}

.floor-side {
	border-radius: 12px;
	padding: 30px;
	color: #fff;
	position: relative;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
	transition: transform 0.1s;
}

.side-bg-icon {
	position: absolute;
	right: -20px;
	bottom: -30px;
	font-size: 160px;
	opacity: 0.15;
	transform: rotate(-15deg);
}

.side-list li {
	margin-bottom: 10px;
	background: rgba(255, 255, 255, 0.15);
	padding: 8px 12px;
	border-radius: 6px;
	font-size: 14px;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;
	backdrop-filter: blur(5px);
	transition: 0.3s;
}

.side-list li:hover {
	transform: translateX(5px);
	background: rgba(255, 255, 255, 0.25);
}

/* 商品网格 */
.goods-list {
	display: grid;
	/* 强制分为4列 */
	grid-template-columns: repeat(4, 1fr);
	gap: 15px;
}

.goods-card {
	/* 确保卡片本身有相对定位和隐藏溢出 */
	position: relative !important;
	overflow: hidden !important;
	border: 1px solid transparent !important;
	box-shadow: none !important;
	transition: all 0.3s;
	cursor: pointer;
}

.goods-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08) !important;
	border-color: var(--hover-color) !important;
}

.goods-img { 
    height: 120px; 
    display: flex; align-items: center; justify-content: center; 
    font-size: 50px; 
    color: #cbd5e1; /* 默认灰色 */
    transition: 0.3s; 
    padding: 10px;
}
/* 悬停时图标变彩色 */
.goods-card:hover .goods-img { 
    transform: scale(1.05); 
    color: var(--hover-color); 
}

.goods-info {
	padding: 10px;
	text-align: center;
}

.goods-name {
	font-size: 14px;
	height: 20px;
	line-height: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	color: #333;
	font-weight: bold;
}

.goods-meta {
	margin: 5px 0;
}

.goods-en {
	font-size: 12px;
	color: #888;
	height: 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.goods-cas {
	font-size: 12px;
	color: #aaa;
	margin-top: 2px;
}

.text-ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.goods-price {
	color: #ef4444;
	font-weight: bold;
	font-size: 16px;
	margin-top: 8px;
}

.hover-action {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 10px;
	background: linear-gradient(90deg, var(--tech-blue), var(--tech-cyan));
	color: #fff;
	text-align: center;
	font-size: 13px;
	transform: translateY(100%);
	transition: 0.3s;
}

.goods-card:hover .hover-action {
	transform: translateY(0);
}

@media (max-width: 992px) {
	.floor-body {
		grid-template-columns: 1fr;
	}

	.floor-side {
		height: 160px;
		margin-bottom: 15px;
	}

	/* 移动端改为两列 */
	.goods-list {
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>